export default "__VITE_ASSET__tcnbtGIe__"